export default {"src":"/_next/static/media/featured-in.17f62a9d.svg","height":24,"width":167,"blurWidth":0,"blurHeight":0};